import React from 'react';
import { Tabs } from 'antd';
import 'styles/ant-design.css';
import { SubmissionDetailsTabProps, getTabs } from './types';
import { useTranslation } from 'react-i18next';

const SubmissionDetailsTab: React.FC<SubmissionDetailsTabProps> = ({
  activeTab,
  onTabChange,
  businessLine,
}) => {
  const { t } = useTranslation();
  const tabs = getTabs(businessLine, t);

  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      items={tabs}
      className="custom-tabs-with-bottom-curve"
    />
  );
};

export default SubmissionDetailsTab;
